import { render, staticRenderFns } from "./PressCenter.vue?vue&type=template&id=6b546f66&scoped=true&"
import script from "./PressCenter.vue?vue&type=script&lang=js&"
export * from "./PressCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b546f66",
  null
  
)

export default component.exports